import { Axis } from '../axis';
import { DrawPass } from '../chart';
import { ChartFeature, GridLineLayerSpecification } from '../chart-props';

export function drawGridLinesLayer(
    pass: DrawPass,
    features: ChartFeature[],
    layer: GridLineLayerSpecification,
    xAxis: Axis,
    yAxis: Axis
) {
    for (const feature of features) {
        if (feature.geometry.type === 'Point') {
            if (layer.layout.axis === 'x') {
                const x = xAxis.project(feature.geometry.coordinates[0], pass.viewState);
                pass.drawer.drawLine([x, pass.viewState.chartViewport.top], [x, pass.viewState.chartViewport.bottom], {
                    color: layer.paint.lineColor,
                    style: layer.paint.lineStyle,
                    width: layer.paint.lineWidth
                });
            } else {
                const y = yAxis.project(feature.geometry.coordinates[1], pass.viewState);
                pass.drawer.drawLine([pass.viewState.chartViewport.left, y], [pass.viewState.chartViewport.right, y], {
                    color: layer.paint.lineColor,
                    style: layer.paint.lineStyle,
                    width: layer.paint.lineWidth
                });
            }
        }
    }
}
